import { render, staticRenderFns } from "./TodoFooter.vue?vue&type=template&id=4499f367&scoped=true&"
import script from "./TodoFooter.vue?vue&type=script&lang=js&"
export * from "./TodoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4499f367",
  null
  
)

export default component.exports